import { tap, catchError, map, finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { DataServiceBase } from '../../../core/service/base/data.service.base';
import { PagedResult } from '../../../core/model/paged-result';
import { LeaseAgreementImdConsumption } from '../../model/lease-agreement-imd-consumption';

@Injectable()
export class LeaseAgreementImdConsumptionService extends DataServiceBase {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, messageService, progressBar, config, 'lease-agreement-imd-consumption');
  }

  getPagedList(leaseAgreementId: string, page: number, pageSize: number): Observable<PagedResult<LeaseAgreementImdConsumption>> {
    this.progressBar.start();
    return this.client
      .post<PagedResult<LeaseAgreementImdConsumption>>(`${this.endpoint}/page`, {
        page: page,
        pageSize: pageSize,
        filter: { entityId: leaseAgreementId },
      })
      .pipe(
        map(response => {
          let result = Object.assign(new PagedResult(), response);
          result.items = response.items.map(i => new LeaseAgreementImdConsumption(i));
          return result;
        }),
        finalize(() => this.progressBar.stop())
      );
  }
}
